import layout from '../layout/index.vue'
import Login from '../views/login/index.vue' //登录
import editPassword from '../views/editPassword/editPassword' //修改密码

let level = sessionStorage.getItem('level')
// 开发中页面模版
import developing from '../views/developing/developing'

// 系统首页
import home from '../views/home/index';

// 机构代理商管理
import agentList from '../views/agentManagement/agentList'; // 机构代理商列表
import moveLineManage from '../views/agentManagement/moveLineManage/moveLineManage'; //移线管理
import setMoveLine from '../views/agentManagement/moveLineManage/setMoveLine'; //移线管理
import addAgent from '../views/agentManagement/components/addAgent'; // 添加机构代理商
import addUser from '../views/agentManagement/components/addAgent2'; // 添加机构代理商
import agentDetail from '../views/agentManagement/components/agentDetail'; // 机构代理商详情
import agentPolicyConfig from '../views/agentManagement/components/agentPolicyConfig'; // 机构代理商政策配置
import agentCashbackList from '../views/agentManagement/agentCashbackList'; // 机构代理商返现记录

// 基础设置
import amortizationSetting from '../views/basicSetting/amortizationSetting'; //分期设置
import platformSetting from '../views/basicSetting/platormSet/BS_PlatformSetting'; //平台设置
import paramSetting from '../views/basicSetting/paramSet/BS_ParamSetting'; //参数设置
import agreementSetting from '../views/basicSetting/agreement/BS_AgreementSetting'; //协议设置
import editAgreement from '../views/basicSetting/agreement/BS_settingInfo'; //编辑协议
import aboutUs from '../views/basicSetting/aboutUs/BS_AboutUs'; //关于我们
import dataAccount from '../views/basicSetting/dataAccount/BS_dataAccount'; //数据账号

// 权限管理
import roleManagement from '../views/permissionManagement/roleList'; //角色管理
import operatorManagement from '../views/permissionManagement/operatorList'; //操作员管理

// 对账管理
import contrastList from '../views/contrastManagement/contrastList'; //对账记录
import forWard from '../views/contrastManagement/forWard'; //对账记录下载
import riskClass from '../views/contrastManagement/riskClass'; //银盛管家风控记录
import riskClassDetail from '../views/contrastManagement/riskClassDetail'; //银盛管家风控记录(风控)
import riskClassOrderDetail from '../views/contrastManagement/riskClassOrderDetail'; //银盛管家风控记录(调单)
import contrastDownload from '../views/contrastManagement/contrastDownload'; //对账记录下载

// 用户管理
import userClassSetting from '../views/userManagement/userClassSetting'; //用户分类设置
import userList from '../views/userManagement/user/UM_userList'; //用户列表
import userAgreement from '../views/userManagement/user/UM_userAgreement'; //用户列表
import userLevel from '../views/userManagement/userLevel'; //用户层级
import userInfo from '../views/userManagement/user/UM_userInfo'; //用户详情
import loanManagement from '../views/userManagement/loanManagement/UM_loanList'; //贷款管理-流水
import loanInfo from '../views/userManagement/loanManagement/UM_loanInfo'; //贷款详情-流水
import installmentLoan from '../views/userManagement/installmentLoanList'; //贷款管理-分期
import installmentLoanInfo from '../views/userManagement/components/installmentLoanInfo'; //贷款管理-详情
import repaymentManagement from '../views/userManagement/repaymentManagement/UM_repaymentList'; //还款比例管理
import realNameAuthentication from '../views/userManagement/realNameAuthentication/UM_realNameList'; 
//实名认证
import changeRealMessage from '../views/userManagement/realNameAuthentication/changeRealMessage'; // 修改实名认证
import blockedAccount from '../views/userManagement/blockedAccount/UM_blockedList'; //冻结账户
import accountChangeRecord from '../views/userManagement/accountChangeRecord/UM_changeList'; //账户变更记录
import placeOfReceipt from '../views/userManagement/placeOfReceipt/UM_placeList'; //收货地址
import emailAddress from '../views/userManagement/emailAddress/UM_emailList'; //邮箱地址
import bankCard from '../views/userManagement/bankCard/UM_cardList'; //银行卡
import smsVerificationCode from '../views/userManagement/smsVerificationCode/UM_messageList'; //短信验证码
import phaseAddRate from '../views/userManagement/phaseAddRate/phaseAddRate'; //阶段涨价
import phaseRateDetail from '../views/userManagement/phaseRateDetail/phaseRateDetail'; //阶段涨价详情

// 机具管理
import brandManagement from '../views/machineManagement/brandManagement/MAM_brandList'; //终端类型-管理
import brandRewardList from '../views/machineManagement/brandManagement/MAM_brandRewardList'; //终端类型-活动

import nextYearFlowCardList from '../views/machineManagement/brandManagement/nextYearFlowCard'; //次年流量卡设置列表
import nextYearFlowCardSecond from '../views/machineManagement/brandManagement/nextYearFlowCardSecond'; //次年流量卡
import nextYearFlowCardDetails from '../views/machineManagement/brandManagement/nextYearFlowCardDetails'; //次年流量卡配置详情
import debitCardPolicyList from '../views/machineManagement/brandManagement/debitCardPolicyList'; //贷记卡刷卡调价政策列表

import merchantRate from '../views/machineManagement/brandManagement/MAM_merchantRate'; //终端类型-商户费率
import risePrice from '../views/machineManagement/brandManagement/MAM_risePrice'; //终端类型-涨价后费率
import terminalMerchant from '../views/machineManagement/terminalMerchant/MAM_terminalList'; //终端&商户
import UserTerminalStock from '../views/machineManagement/stockManagement/UserTerminalStock'; //库存管理(新)
import UtsInfo from '../views/machineManagement/stockManagement/UtsInfo'; //终端兑换详情

import stockInOutQuery from '../views/machineManagement/stockInOutQuery/MAM_queryList'; //出入库记录查询
import transferManagement from '../views/machineManagement/transferManagement/MAM_transferList'; //划拨管理
import equipment from '../views/machineManagement/terminalList/MAM_terminalList'; //终端列表

import bigDividendRule from '../views/ruleRawardManger/bigDividendRule/bigDividendRule'; //大盘分红规则配置
import managementAwardRule from '../views/ruleRawardManger/managementAwardRule/managementAwardRule'; //管理奖规则配置
import bigDividendFinishList from '../views/ruleRawardManger/bigDividendFinishList/bigDividendFinishList'; //大盘分红达标列表
import mangerAwardFinishList from '../views/ruleRawardManger/mangerAwardFinishList/mangerAwardFinishList'; //管理奖达标列表
import downSalaryAwardFinishList from '../views/ruleRawardManger/downSalaryAwardFinishList/downSalaryAwardFinishList'; //底薪奖达标列表
import effectiveMerchartList from '../views/ruleRawardManger/downSalaryAwardFinishList/effectiveMerchartList'; //底薪奖新增有效商户
import ationSnDetailList from '../views/ruleRawardManger/downSalaryAwardFinishList/ationSnDetailList'; //底薪奖新增活跃率商户
import ationSecondSnDetailList from '../views/ruleRawardManger/downSalaryAwardFinishList/ationSecondSnDetailList'; //底薪奖新增活跃率商户
import downSalaryAwardRule from '../views/ruleRawardManger/downSalaryAwardRule/downSalaryAwardRule'; //底薪奖活动配置
import downSalaryAwardRuleList from '../views/ruleRawardManger/downSalaryAwardRuleList/downSalaryAwardRuleList'; //底薪奖规则配置
import downSalarySignUpList from '../views/ruleRawardManger/downSalarySignUpList/downSalarySignUpList'; //底薪奖报名列表


import exchangeManagement from '../views/machineManagement/exchangeDetails/exchangeManagement'; //终端兑换管理
import newExchangeManagement from '../views/machineManagement/exchangeDetails/newExchangeManagement'; //新终端兑换管理
import exchangeDetails from '../views/machineManagement/exchangeDetails/exchangeDetails'; //终端兑换明细
import exchangePointIncome from '../views/machineManagement/exchangeDetails/exchangePointIncome'; //积分收入明细
import pointDuiAllDetailList from '../views/machineManagement/exchangeDetails/pointDuiAllDetailList'; //积分兑换全平台


// import terminalExtend from '../views/machineManagement/terminalList/MAM_terminalDate'; //终端政策未激活时间延长
import transferTerminal from '../views/machineManagement/transferManagement/MAM_transferTerminal'; //划拨管理
import transferTerminalAgent from '../views/machineManagement/transferManagement/MAM_transferTerminalAgent'; //代理划拨管理
import transferTerminalBack from '../views/machineManagement/transferManagement/MAM_transferTerminalBack'; //划拨退回
import transferTerminalInfo from '../views/machineManagement/transferManagement/MAM_transferTerminalInfo'; //划拨管理获取待接收
import rateChange from '../views/machineManagement/rateChange/MAM_rateList'; //费率修改审批
import rateInfo from '../views/machineManagement/rateChange/MAM_rateInfo'; //费率修改审批详情
import terminalReturn from '../views/machineManagement/terminalReturn/MAM_terminalReturn'; //终端退回
import terminalTransaction from '../views/machineManagement/terminalList/MAM_terminalTransaction'; //交易明细
import terminalAdjust from '../views/machineManagement/terminalAdjust/MAM_TerminalAdjustList'; //终端调价
import terminalAdjustInfo from '../views/machineManagement/terminalAdjust/MAM_TerminalAdjustInfo'; //终端调价列表
import terminalAdjustDetail from '../views/machineManagement/terminalAdjust/MAM_TerminalAdjustDetail'; //终端调价数据
import debitCardEquipment from '../views/machineManagement/terminalAdjust/debitCardEquipment'; //贷记卡刷卡调价列表
import creditCardaDjustment from '../views/machineManagement/creditCardaDjustment/creditCardaDjustment'; //贷记卡刷卡调价管理-新
import policyDetails from '../views/machineManagement/creditCardaDjustment/policyDetails'; //贷记卡刷卡调价管理 详情

import gearConfigurationList from '../views/machineManagement/gearConfiguration/gearConfigurationList'; //2.0政策档位配置

//规则管理
import riskControl from '../views/machineManagement/riskControl/MAM_riskControlList'; //风控规则配置
import riskControlLog from '../views/machineManagement/riskControlLog/MAM_riskControlLogList'; //风控规则触发记录

// 数据管理
import turnoverAttainRecord from '../views/dataManagement/turnoverAttainRecord/DM_attainRecord'; //交易量达标记录查询
import cashBackRecode from '../views/dataManagement/cashBackRecode/DM_cashBackList'; //押金返现记录查询
import mercServerFinishList from '../views/dataManagement/mercServerFinishList/mercServerFinishList'; //商户服务费达标明细
import merchantWithdrawAudit from '../views/dataManagement/mercServerFinishList/merchantWithdrawAudit'; //商户服务费提现审核

import flowBackRecode from '../views/dataManagement/flowBackRecode/DM_flowBackList'; //流量卡返现记录查询
import flowDeductionRecord from '../views/dataManagement/flowDeductionRecord/flowDeductionRecord'; //流量卡扣费记录查询
// import flowBackRecode from '../views/developing/developing'; //流量卡返现记录查询
import activationRecord from '../views/dataManagement/activationRecord/DM_activationList'; //激活记录查询
import awarding from '../views/dataManagement/awarding/DM_awardingList'; //奖励发放查询
import transactionDetail from '../views/dataManagement/transactionDetail/DM_transctionList'; //交易明细

import SnmodifyPrice from '../views/dataManagement/transactionDetail/SnmodifyPrice'; //终端调价交易

import terminalStatistics from '../views/dataManagement/terminalStatistics/DM_terminalList'; //终端统计
import upsideOrder from '../views/dataManagement/upsideOrders/DM_upsideOrder'; //终端统计
import ladderLog from '../views/dataManagement/ladderLog/DM_ladderLogList'; //交易阶梯奖励
import downloadList from '../views/dataManagement/download/DM_downloadList'; //下载列表
import activityCenter from '../views/dataManagement/activityCenterList'; //活动中心
import superiorSubsidyRecord from '../views/dataManagement/superiorSubsidyRecord'; //上级补贴记录
import riskControlList from '../views/dataManagement/deductionList/DM_riskControlList'; //伪激活扣款
import riskActiveList from '../views/dataManagement/deductionList/DM_riskActiveList'; //未激活扣款
import superiorMoney from '../views/dataManagement/deductionList/DM_superiorMoney'; //流量卡返现记录查询
import subordinateMoney from '../views/dataManagement/deductionList/DM_subordinateMoney'; //流量卡返现记录查询
import transactionHide from '../views/dataManagement/transactionHide/DM_transactionHide'; //数据优化
import transactionHideAdd from '../views/dataManagement/transactionHide/DM_transactionHideAdd'; //数据优化添加
import transactionHideInfo from '../views/dataManagement/transactionHide/DM_transactionHideInfo'; //数据优化添加
// 商户管理
import merchantNet from '../views/merchantManagement/merchantNet'; //商户进件管理列表--银盛
import balanceCashDown from '../views/merchantManagement/ysBalanceCashDown'; //商户余额提现
import balanceCashDownRecord from '../views/merchantManagement/ysBalanceApplyRecordList'; //商户余额提现
import merchantNetMany from '../views/merchantManagement/merchantNetMany'; //商户进件管理列表--杉德+联动
import merchantNetManyInfo from '../views/merchantManagement/merchantNetManyInfo'; //商户进件管理列表--杉德+联动 --详情
import terminalUnbindList from '../views/merchantManagement/terminalUnbindList'; //解绑列表
import merchantNetInfo from '../views/merchantManagement/merchantNetInfo'; //商户详情
import mercSpeBundDetail from '../views/merchantManagement/mercSpeBundDetail'; //商户特惠认证详情
import merchantClassSetting from '../views/merchantManagement/merchantClassList'; //商户分类设置
import rateTemplateManagement from '../views/merchantManagement/rateTemplateList'; //费率模板管理
import merchantNetInfoUpdate from "../views/merchantManagement/merchantNetInfoUpdate";//商户修改
import companyMerchantNet from '../views/merchantManagement/companyMerchantNet'; //商户进件管理列表
import companyMerchantNetAdd from '../views/merchantManagement/companyMerchantNetAdd'; //企业商户进件新增
import companyMerchantNetUpdate from '../views/merchantManagement/companyMerchantNetUpdate'; //企业商户进件修改
import MerchantRefundList from '../views/dataManagement/merchantRefundList/merchantRefundList'; //商户退汇列表
import companyMerchantNetUpdates from '../views/merchantManagement/companyMerchantNetUpdates'; //企业商户进件修改
import companyMerchantNetInfo from '../views/merchantManagement/companyMerchantNetInfo'; //企业商户进件详情
import companyMerchantNetModify from '../views/merchantManagement/companyMerchantNetModify'; //企业商户绑定终端
import merchantDeduction from '../views/merchantManagement/merchantDeductionList'; //终端列表
import merchantDeductionAdd from '../views/merchantManagement/merchantDeductionAdd'; //终端列表
import forceUnBind from '../views/merchantManagement/FM_forceUnBindList'; //强制解绑
import rateDiscountSettings from '../views/merchantManagement/rateDiscountSettings'; //费率折扣设置
import merchantSurchargeManagement from '../views/merchantManagement/merchantSurchargeManagement/merchantSurchargeManagement'; //商户附加费管理
import merchantSurchargeManagementDetails from '../views/merchantManagement/merchantSurchargeManagement/merchantSurchargeManagementDetails'; //商户附加费管理详情
import mobilePOSMerchant from '../views/merchantManagement/mobilePOSMerchant/mobilePOSMerchant'; //手机pos商户
import mobilePOSMerchantInfo from '../views/merchantManagement/mobilePOSMerchant/mobilePOSMerchantInfo'; //手机pos商户详情
// 财务管理
import userWithdrawal from '../views/financialManagement/userWithdrawal/FM_withdrawalList.vue'; //用户提现
import userPurse from '../views/financialManagement/usersPurse/FM_purseList'; //用户钱包
import userFinancial from '../views/financialManagement/usersOfFinancial/FM_financial'; //用户财务记录
import userAlipayRecord from '../views/financialManagement/UserAlipay/FM_alipayList'; //用户支付宝支付记录
import platformAccount from '../views/financialManagement/platformAccount/FM_accountList'; //平台账户
import agentinaccountList from '../views/financialManagement/platformAccount/FM_agentinaccountList'; //平台账户分润列表
import agentaccountList from '../views/financialManagement/platformAccount/FM_agentaccountList'; //平台账户分润列表
import agentoutaccountList from '../views/financialManagement/platformAccount/FM_agentoutaccountList'; //平台账户分润提现列表
import moneyStatistics from '../views/financialManagement/moneyStatistics'; //平台分润支出统计
import agentAccountAllList from '../views/financialManagement/platformAccount/FM_agentAccountAllList'; //活动账户明细
import agentAccountMarketAllList from '../views/financialManagement/platformAccount/FM_agentAccountMarketAllList'; //市场账户明细
import agentAccountProfitAllList from '../views/financialManagement/platformAccount/FM_agentAccountProfitAllList'; //分润账户明细
import agentWithdrawal from '../views/financialManagement/agentWithdrawal/FM_agentwithdrawalList'; //提现
import agentWithdrawalLists from '../views/financialManagement/agentWithdrawal/FM_agentWithdrawalLists'; //提现列表
import agentExamine from '../views/financialManagement/agentWithdrawal/FM_agentExamineList'; //提现审核
import rateMonth from '../views/financialManagement/agentWithdrawal/FM_rateMonth'; //提现列表
import marketAccount from '../views/financialManagement/marketAccount/FM_marketAccountList'; //加码账户列表
import penaltyDeduction from '../views/financialManagement/penaltyDeduction/FM_dealpunish'; //处罚扣款
import flowBackExtra from '../views/financialManagement/flowBackExtra/FM_list'; //流量卡扣费

// APP管理
import banner from '../views/appManagement/banner/APP_bannerList'; //banner图管理
import bannerInfo from '../views/appManagement/banner/APP_bannerInfo'; //banner图详情
import recruit from '../views/appManagement/recruit/APP_recruitList'; //招募背景管理
import recruitInfo from '../views/appManagement/recruit/APP_recruitInfo'; //招募背景详情
import feedback from '../views/appManagement/feedback/APP_feedbackList'; //意见反馈
import informationList from '../views/appManagement/information/APP_informationList'; //消息列表
import informationInfo from '../views/appManagement/information/APP_informationInfo'; //消息详情

// 商学院
import articleCategory from '../views/businessCollege/articleCategory/BC_categoryList'; //文章分类
import articleList from '../views/businessCollege/ArticleList/BC_articleList'; //文章列表
import articleInfo from '../views/businessCollege/ArticleList/BC_articleInfo'; //文章详情

//帮助中心
import helpClass from '../views/helpCenter/helpClass/HC_classList'; //帮助分类
import helpList from '../views/helpCenter/helpList/HC_helpList'; //帮助列表
import helpInfo from '../views/helpCenter/helpList/HC_helpInfo'; //帮助详情

// 客服管理
import serviceApplication from '../views/serviceManagement/serviceApplicationList'; //客服申请
import serviceRenew from '../views/serviceManagement/serviceRenewList'; //客服续费

// 团长管理
import teamLeaderManagementList from '../views/teamLeaderManagement/teamLeaderManagementList'; //团长管理
import costing from '../views/teamLeaderManagement/costing'; //成本核算
import rewardDetails from '../views/teamLeaderManagement/rewardDetails'; //奖励明细
import teamMoneyShenList from '../views/teamLeaderManagement/teamMoneyShenList'; //团长提现审核
import teamTixianManger from '../views/teamLeaderManagement/tixianmangerandrecord/tixianManger'; //提现管理
import teamTixianRecord from '../views/teamLeaderManagement/tixianmangerandrecord/tixianrecord'; //提现记录

import terminalPickup from '../views/teamLeaderManagement/costingDetails/terminalPickup'; //终端拿货
import differenceShareProfit from '../views/teamLeaderManagement/costingDetails/differenceShareProfit'; //分润差额
import trafficCardSharing from '../views/teamLeaderManagement/costingDetails/trafficCardSharing'; //流量卡分成

import profitWithdrawalPoint from '../views/teamLeaderManagement/costingDetails/profitWithdrawalPoint'; //分润账户提现税点
import activityWithdrawalPoint from '../views/teamLeaderManagement/costingDetails/activityWithdrawalPoint'; //活动账户提现税点
import depositWithdrawalPoint from '../views/teamLeaderManagement/costingDetails/depositWithdrawalPoint'; //押金账户提现税点
import rewardAccountShaiDian from '../views/teamLeaderManagement/costingDetails/rewardAccountShaiDian'; //奖励账户提现税点
import specialRewardDetail from '../views/teamLeaderManagement/costingDetails/specialRewardDetail'; //特惠奖励账户提现税点
import bigAwardDetail from '../views/teamLeaderManagement/costingDetails/bigAwardDetail'; //大盘分红账户提现税点
import mangerAwardDetail from '../views/teamLeaderManagement/costingDetails/mangerAwardDetail'; //管理奖账户提现税点
import downSalaryReward from '../views/teamLeaderManagement/costingDetails/downSalaryReward'; //底薪奖账户提现税点
import flowCardCostDetail from '../views/teamLeaderManagement/costingDetails/flowCardCostDetail'; //流量卡账户提现税点



//自由调价
import rightsManagement from '../views/freeAdjustmentPrice/rightsManagement'; //自由调价权限管理
import blacklistManagement from '../views/freeAdjustmentPrice/blacklistManagement'; //调价黑名单管理
import rateAdjustmentRecord from '../views/freeAdjustmentPrice/rateAdjustmentRecord'; //费率调价记录
import secondsAdjustmentRecord from '../views/freeAdjustmentPrice/secondsAdjustmentRecord'; //秒到费调价记录
import freeFenMoney from '../views/freeAdjustmentPrice/freeFenMoney'; //秒到费调价记录


import saleMangerPerson from '../views/saleManger/saleMangerPerson'; //销售管理人员列表
import salePersonLinkAgent from '../views/saleManger/salePersonLinkAgent'; //销售人员关联代理
import salePersonTask from '../views/saleManger/salePersonTask'; //销售人员任务列表
import saleTixianShen from '../views/saleManger/saleTixianShen'; //销售提现审核
import saleRewardDetail from '../views/saleManger/saleRewardDetail'; //销售奖励明细

import channelRateUpLimit from '../views/platRateUp/channelRateUpLimit'; //渠道阈值设置
import riseRateManager from '../views/platRateUp/riseRateManager'; //涨价方案管理
import riseRateWhiterList from '../views/platRateUp/riseRateWhiterList'; //涨价白名单管理
import riseRateRecord from '../views/platRateUp/riseRateRecord'; //费率涨价记录
import platUpRateRecord from '../views/platRateUp/platUpRateRecord'; //平台费率涨价记录
import riseSecondRecord from '../views/platRateUp/riseSecondRecord'; //秒到费涨价记录
import policyDetails2 from '../views/platRateUp/policyDetails'; //涨价方案管理 详情
import agentMoreRewardRecord from '../views/dataManagement/agentMoreRewardRecord/agentMoreRewardRecord'; //代理商加码奖励记录
import teamtMoreRewardRecord from '../views/dataManagement/agentMoreRewardRecord/teamtMoreRewardRecord'; //代理商加码奖励记录

import grayPlanList from '../views/grayPlan/grayPlanList'; //灰名单优化方案管理
import grayPlanNewList from '../views/grayPlan/grayPlanNewList'; //灰名单优化方案管理
import grayPlanTraceList from '../views/grayPlan/grayPlanTraceList'; //灰名单数据恢复管理
import grayPlanTraceNormalList from '../views/grayPlan/grayPlanTraceNormalList'; //灰名单数据恢复记录
import agentWhiterList from '../views/grayPlan/agentWhiterList'; 
import agentWhiterListNew from '../views/grayPlan/agentWhiterListNew'; 
import mercWhiterList from '../views/grayPlan/mercWhiterList'; 
import mercWhiterListNew from '../views/grayPlan/mercWhiterListNew'; 

//路由文件
const routes = [
    {
        path: '/login',
        component: Login,
        hidden: true
    },
    {
        path: '/',
        name: 'home',
        meta: {
            title: '系统首页'
        },
        children: [
            {
                path: '/',
                component: home,
                meta: {
                    title: '系统首页'
                },
            },
        ],
        component: layout,
    },
    {
        path: '/agentManagement',
        name: 'agentManagement',
        meta: {
            title: '机构代理商管理'
        },
        component: layout,
        children: [
            {
                path: '/agentList',
                name: 'agentList',
                meta: {
                    title: '机构代理商列表'
                },
                component: agentList
            },
            {
                path: '/addAgent',
                name: 'addAgent',
                meta: {
                    title: '添加签约代理'
                },
                component: addAgent
            },
            {
                path: '/agentDetail/:id',
                name: 'agentDetail',
                meta: {
                    title: '机构代理商详情'
                },
                component: agentDetail
            },
            {
                path: '/agentPolicyConfig/:id',
                name: 'agentPolicyConfig',
                meta: {
                    title: '机构代理商政策配置'
                },
                component: agentPolicyConfig
            },
            {
                path: '/agentCashbackList',
                name: 'agentCashbackList',
                meta: {
                    title: '机构代理商返现记录'
                },
                component: agentCashbackList
            }
        ]
    },
    {
        path: '/base',
        name: 'base',
        meta: {
            title: '基础设置'
        },
        component: layout,
        children: [
            {
                path: '/amortizationSetting',
                name: 'amortizationSetting',
                meta: {
                    title: '分期设置'
                },
                component: amortizationSetting
            },
            {
                path: '/setPlatform',
                name: 'setPlatform',
                meta: {
                    title: '平台设置'
                },
                component: platformSetting
            },
            {
                path: '/paramSetting',
                name: 'paramSetting',
                meta: {
                    title: '参数设置'
                },
                component: paramSetting
            },
            {
                path: '/setAgreements',
                name: 'setAgreements',
                meta: {
                    title: '协议设置'
                },
                component: agreementSetting
            },
            {
                path: '/editAgreement',
                name: 'editAgreement',
                meta: {
                    title: '编辑协议'
                },
                component: editAgreement
            },
            {
                path: '/aboutUs',
                name: 'aboutUs',
                meta: {
                    title: '关于我们'
                },
                component: aboutUs
            },
            {
                path: '/dataAccount',
                name: 'dataAccount',
                meta: {
                    title: '数据账号'
                },
                component: dataAccount
            },
        ]
    },
    {
        path: '/authority',
        name: 'authority',
        meta: {
            title: '权限管理'
        },
        component: layout,
        children: [
            {
                path: '/roleManagement',
                name: 'roleManagement',
                meta: {
                    title: '角色管理'
                },
                component: roleManagement
            },
            {
                path: '/operatorManagement',
                name: 'operatorManagement',
                meta: {
                    title: '操作员管理'
                },
                component: operatorManagement
            }
        ]
    },
    {
        path: '/contrast',
        name: 'contrast',
        meta: {
            title: '银盛管家信息模块'
        },
        component: layout,
        children: [
            {
                path: '/contrastList',
                name: 'contrastList',
                meta: {
                    title: '对账记录'
                },
                component: level == 0 ? contrastList : developing
            },
            {
                path: '/contrastDownload',
                name: 'contrastDownload',
                meta: {
                    title: '对账文件下载'
                },
                component: level == 0 ? contrastDownload : developing
            },
            {
                path: '/forWard',
                name: 'forWard',
                meta: {
                    title: '账户流水'
                },
                component: level == 0 ? forWard : developing
            },
            {
                path: '/riskClass',
                name: 'riskClass',
                meta: {
                    title: '风控列表'
                },
                component: level == 0 ? riskClass : developing
            },
            {
                path: '/riskClassDetail',
                name: 'riskClassDetail',
                meta: {
                    title: '风控处理(案例)'
                },
                component: level == 0 ? riskClassDetail : developing
            },
            {
                path: '/riskClassOrderDetail',
                name: 'riskClassOrderDetail',
                meta: {
                    title: '风控处理(调单)'
                },
                component: level == 0 ? riskClassOrderDetail : developing
            },
        ]
    },
    {
        path: '/user',
        name: 'user',
        meta: {
            title: '代理商管理'
        },
        component: layout,
        children: [
            {
                path: '/userClassSetting',
                name: 'userClassSetting',
                meta: {
                    title: '代理商列表'
                },
                component: userClassSetting
            },
            {
                path: '/moveLineManage',
                name: 'moveLineManage',
                meta: {
                    title: '移线管理'
                },
                component: moveLineManage
            },
            {
                path: '/setMoveLine',
                name: 'setMoveLine',
                meta: {
                    title: '设置移线'
                },
                component: setMoveLine
            },
            {
                path: '/userList',
                name: 'userList',
                meta: {
                    title: '代理商列表'
                },
                component: userList
            },
            {
                path: '/userAgreement',
                name: 'userAgreement',
                meta: {
                    title: '协议列表'
                },
                component: userAgreement
            },

            {
                path: '/addUser',
                name: 'addUser',
                meta: {
                    title: '添加签约代理'
                },
                component: addUser
            },
            {
                path: '/userLevel',
                name: 'userLevel',
                meta: {
                    title: '代理商层级'
                },
                component: userLevel
            },
            {
                path: '/userInfo',
                name: 'userInfo',
                meta: {
                    title: '代理商详情'
                },
                component: userInfo
            },
            {
                path: '/loan',
                name: 'loan',
                meta: {
                    title: '贷款管理'
                },
                component: loanManagement
            },
            {
                path: '/loanInfo',
                name: 'loanInfo',
                meta: {
                    title: '贷款详情'
                },
                component: loanInfo
            },
            {
                path: '/installmentLoan',
                name: 'installmentLoan',
                meta: {
                    title: '贷款管理'
                },
                component: installmentLoan
            },
            {
                path: '/installmentLoanInfo',
                name: 'installmentLoanInfo',
                meta: {
                    title: '贷款详情'
                },
                component: installmentLoanInfo
            },
            {
                path: '/repayment',
                name: 'repayment',
                meta: {
                    title: '还款比例管理'
                },
                component: repaymentManagement
            },
            {
                path: '/realName',
                name: 'realName',
                meta: {
                    title: '实名认证'
                },
                component: realNameAuthentication
            },
            {
                path: '/changeRealMessage',
                name: 'changeRealMessage',
                meta: {
                    title: '修改代理实名信息'
                },
                component: changeRealMessage
            },
            
            {
                path: '/blockedAccount',
                name: 'blockedAccount',
                meta: {
                    title: '冻结账户'
                },
                component: blockedAccount
            },
            {
                path: '/accountChange',
                name: 'accountChange',
                meta: {
                    title: '账户变更记录'
                },
                component: accountChangeRecord
            },
            {
                path: '/placeOfReceipt',
                name: 'placeOfReceipt',
                meta: {
                    title: '收货地址'
                },
                component: placeOfReceipt
            },
            {
                path: '/emailAddress',
                name: 'emailAddress',
                meta: {
                    title: '邮箱地址'
                },
                component: emailAddress
            },
            {
                path: '/bankCard',
                name: 'bankCard',
                meta: {
                    title: '银行卡'
                },
                component: bankCard
            },
            {
                path: '/messageCode',
                name: 'messageCode',
                meta: {
                    title: '短信验证码'
                },
                component: smsVerificationCode
            },
            {
                path: '/phaseAddRate',
                name: 'phaseAddRate',
                meta: {
                    title: '阶段性涨价'
                },
                component: phaseAddRate
            },
            {
                path: '/phaseRateDetail',
                name: 'phaseRateDetail',
                meta: {
                    title: '阶段性涨价详情'
                },
                component: phaseRateDetail
            } 
        ]
    },
    {
        path: '/platRateUp',
        name: 'platRateUp',
        meta: {
            title: '平台涨价管理'
        },
        component: layout,
        children:[
            {
                path: '/channelRateUpLimit',
                name: 'channelRateUpLimit',
                meta: {
                    title: '渠道阈值设置'
                },
                component: channelRateUpLimit
            },
            {
                path: '/riseRateManager',
                name: 'riseRateManager',
                meta: {
                    title: '涨价方案管理'
                },
                component: riseRateManager
            },
            {
                path: '/policyDetails2',
                name: 'policyDetails2',
                meta: {
                    title: '涨价方案详情'
                },
                component: policyDetails2
            },
            {
                path: '/riseRateWhiterList',
                name: 'riseRateWhiterList',
                meta: {
                    title: '涨价白名单管理'
                },
                component: riseRateWhiterList
            },
            {
                path: '/riseRateRecord',
                name: 'riseRateRecord',
                meta: {
                    title: '费率涨价记录'
                },
                component: riseRateRecord
            },
            {
                path: '/platUpRateRecord',
                name: 'platUpRateRecord',
                meta: {
                    title: '涨价分润明细'
                },
                component: platUpRateRecord
            },
            {
                path: '/riseSecondRecord',
                name: 'riseSecondRecord',
                meta: {
                    title: '秒到费涨价记录'
                },
                component: riseSecondRecord
            }
        ]
        
    },
    {
       path: '/machine',
       name: 'machine',
       meta: {
           title: '分红管理'
       },
       component: layout,
       children: [
           {
               path: '/bigDividendRule',
               name: 'bigDividendRule',
               meta: {
                   title: '大盘分红规则配置'
               },
               component: bigDividendRule
           },
           {
               path: '/managementAwardRule',
               name: 'managementAwardRule',
               meta: {
                   title: '管理奖规则配置'
               },
               component: managementAwardRule
           },
           {
               path: '/bigDividendFinishList',
               name: 'bigDividendFinishList',
               meta: {
                   title: '大盘分红达标明细'
               },
               component: bigDividendFinishList
           },
           {
               path: '/mangerAwardFinishList',
               name: 'mangerAwardFinishList',
               meta: {
                   title: '管理奖达标明细'
               },
               component: mangerAwardFinishList
           },
           {
               path: '/downSalaryAwardFinishList',
               name: 'downSalaryAwardFinishList',
               meta: {
                   title: '底薪奖达标明细'
               },
               component: downSalaryAwardFinishList
           },
           {
               path: '/effectiveMerchartList',
               name: 'effectiveMerchartList',
               meta: {
                   title: '有效商户明细'
               },
               component: effectiveMerchartList
           },
           {
               path: '/ationSnDetailList',
               name: 'ationSnDetailList',
               meta: {
                   title: '活跃终端明细'
               },
               component: ationSnDetailList
           },
           {
               path: '/ationSecondSnDetailList',
               name: 'ationSecondSnDetailList',
               meta: {
                   title: '次月累计交易量明细'
               },
               component: ationSecondSnDetailList
           },
           
           {
               path: '/downSalaryAwardRule',
               name: 'downSalaryAwardRule',
               meta: {
                   title: '底薪奖活动管理'
               },
               component: downSalaryAwardRule
           },
           {
               path: '/downSalaryAwardRuleList',
               name: 'downSalaryAwardRuleList',
               meta: {
                   title: '底薪奖规则配置'
               },
               component: downSalaryAwardRuleList
           },
           {
               path: '/downSalarySignUpList',
               name: 'downSalarySignUpList',
               meta: {
                   title: '底薪奖报名明细'
               },
               component: downSalarySignUpList
           },
       ]
    },
    {
        path: '/machine',
        name: 'machine',
        meta: {
            title: '终端管理'
        },
        component: layout,
        children: [
            {
                path: '/brand',
                name: 'brand',
                meta: {
                    title: '终端类型管理'
                },
                component: brandManagement
            },
            {
                path: '/gearConfigurationList',
                name: 'gearConfigurationList',
                meta: {
                    title: '2.0政策档位配置'
                },
                component: gearConfigurationList
            },
            {
                path: '/brandRewardList',
                name: 'brandRewardList',
                meta: {
                    title: '营销活动'
                },
                component: brandRewardList,
                // children:[
                    
                // ]
            },
            {
                path: '/nextYearFlowCardList',
                name: 'nextYearFlowCardList',
                meta: {
                    title: '次年流量卡设置'
                },
                component: nextYearFlowCardList,
            },
            {
                path: '/nextYearFlowCardSecond',
                name: 'nextYearFlowCardSecond',
                meta: {
                    title: '阶段性流量卡设置'
                },
                component: nextYearFlowCardSecond,
            },
            
            {
                path: '/nextYearFlowCardDetails',
                name: 'nextYearFlowCardDetails',
                meta: {
                    title: '次年流量卡配置详情'
                },
                component: nextYearFlowCardDetails,
            },
            {
                path: '/debitCardPolicyList',
                name: 'debitCardPolicyList',
                meta: {
                    title: '贷记卡刷卡调价政策列表'
                },
                component: debitCardPolicyList,
            },
            {
                path: '/merchantRate',
                name: 'merchantRate',
                meta: {
                    title: '商户费率'
                },
                component: merchantRate
            },
            {
                path: '/risePrice',
                name: 'risePrice',
                meta: {
                    title: '涨价后费率'
                },
                component: risePrice
            },
            {
                path: '/terminalMerchant',
                name: 'terminalMerchant',
                meta: {
                    title: '终端&商户'
                },
                component: terminalMerchant
            },
            {
                path: '/stockManagement',
                name: 'stockManagement',
                meta: {
                    title: '库存管理'
                },
                // component: stockManagement
                component:UserTerminalStock
            },
            {
                path: '/UtsInfo',
                name: 'UtsInfo',
                meta: {
                    title: '终端兑换'
                },
                component:UtsInfo
            },
            {
                path: '/terminalTransaction',
                name: 'terminalTransaction',
                meta: {
                    title: '终端交易明细'
                },
                component: terminalTransaction
            },

            {
                path: '/stockInOut',
                name: 'stockInOut',
                meta: {
                    title: '出入库记录查询'
                },
                component: stockInOutQuery
            },
            {
                path: '/transfer',
                name: 'transfer',
                meta: {
                    title: '划拨管理'
                },
                component: transferManagement
            },
            {
                path: '/equipment',
                name: 'equipment',
                meta: {
                    title: '终端列表'
                },
                component: equipment
            },
            {
                path: '/transferTerminal',
                name: 'transferTerminal',
                meta: {
                    title: '终端划拨'
                },
                component: transferTerminal
            },
            {
                path: '/transferTerminalAgent',
                name: 'transferTerminalAgent',
                meta: {
                    title: '终端划拨'
                },
                component: transferTerminalAgent
            },
            {
                path: '/transferTerminalBack',
                name: 'transferTerminalBack',
                meta: {
                    title: '终端划拨退回'
                },
                component: transferTerminalBack
            },//transferTerminalBack
            {
                path: '/transferTerminalInfo',
                name: 'transferTerminalInfo',
                meta: {
                    title: '终端划拨'
                },
                component: transferTerminalInfo
            },
            {
                path: '/rateChange',
                name: 'rateChange',
                meta: {
                    title: '费率修改审批'
                },
                component: rateChange
            },
            {
                path: '/rateInfo',
                name: 'rateInfo',
                meta: {
                    title: '费率修改审批详情'
                },
                component: rateInfo
            },
            {
                path: '/terminalReturn',
                name: 'terminalReturn',
                meta: {
                    title: '终端退回'
                },
                component: terminalReturn
            },
            {
                path: '/riskControl',
                name: 'riskControl',
                meta: {
                    title: '风控规则配置'
                },
                // component: riskControl
                component: level == 0 ? riskControl : developing
            },
            {
                path: '/riskControlLog',
                name: 'riskControlLog',
                meta: {
                    title: '风控规则触发记录'
                },
                component: level == 0 ? riskControlLog : developing
            },
            {
                path: '/debitCardEquipment',
                name: 'debitCardEquipment',
                meta: {
                    title: '贷记卡刷卡调价终端列表'
                },
                component: debitCardEquipment
            },
            {
                path: '/creditCardaDjustment',
                name: 'creditCardaDjustment',
                meta: {
                    title: '贷记卡刷卡调价管理-新'
                },
                component: creditCardaDjustment
            },
            {
                path: '/policyDetails',
                name: 'policyDetails',
                meta: {
                    title: '贷记卡刷卡调价管理详情'
                },
                component: policyDetails
            },
            {
                path: '/terminalAdjust',
                name: 'terminalAdjust',
                meta: {
                    title: '终端调价'
                },
                component: terminalAdjust
            },
            {
                path: '/terminalAdjustInfo',
                name: 'terminalAdjustInfo',
                meta: {
                    title: '终端调价详情'
                },
                component: terminalAdjustInfo
            },
            {
                path: '/terminalAdjustDetail',
                name: 'terminalAdjustDetail',
                meta: {
                    title: '终端调价数据'
                },
                component: terminalAdjustDetail
            },
        ]
    },
    {
        path: '/exchanget',
        name: 'exchange',
        meta: {
            title: '兑换管理'
        },
        component: layout,
        children: [
            {
                path: '/pointDuiAllDetailList',
                name: 'pointDuiAllDetailList',
                meta: {
                    title: '积分兑换明细（全平台）'
                },
                component: pointDuiAllDetailList
            },
            {
                path: '/exchangeManagement',
                name: 'exchangeManagement',
                meta: {
                    title: '终端兑换申请'
                },
                component: exchangeManagement
            },
            {
                path: '/newExchangeManagement',
                name: 'newExchangeManagement',
                meta: {
                    title: '积分兑换申请'
                },
                component: newExchangeManagement
            },
            {
                path: '/exchangeDetails',
                name: 'exchangeDetails',
                meta: {
                    title: '终端兑换明细'
                },
                component: exchangeDetails
            },
            {
                path: '/exchangePointIncome',
                name: 'exchangePointIncome',
                meta: {
                    title: '积分收入明细'
                },
                component: exchangePointIncome
            }, 
        ]
    },
    {
        path: '/data',
        name: 'data',
        meta: {
            title: '数据管理'
        },
        component: layout,
        children: [
            {
                path: '/flowDeductionRecord',
                name: 'flowDeductionRecord',
                meta: {
                    title: '流量卡扣费记录查询'
                },
                component: flowDeductionRecord
            },
            {
                path: '/turnoverAttainRecord',
                name: 'turnoverAttainRecord',
                meta: {
                    title: '交易量达标记录查询'
                },
                component: turnoverAttainRecord
            },
            {
                path: '/activationRecord',
                name: 'activationRecord',
                meta: {
                    title: '激活记录查询'
                },
                component: activationRecord
            },
            {
                path: '/agentMoreRewardRecord',
                name: 'agentMoreRewardRecord',
                meta: {
                    title: '终端激活加码奖励明细'
                },
                component: agentMoreRewardRecord
            },
            {
                path: '/teamtMoreRewardRecord',
                name: 'teamtMoreRewardRecord',
                meta: {
                    title: '团长加码奖励明细'
                },
                component: teamtMoreRewardRecord
            },
            {
                path: '/awarding',
                name: 'awarding',
                meta: {
                    title: '奖励发放查询'
                },
                component: awarding
            },
            {
                path: '/transactionDetail',
                name: 'transactionDetail',
                meta: {
                    title: '交易明细'
                },
                component: transactionDetail
            },
            {
                path: '/SnmodifyPrice',
                name: 'SnmodifyPrice',
                meta: {
                    title: '终端调价交易列表'
                },
                component: SnmodifyPrice
            },
            {
                path: '/transactionHide',
                name: 'transactionHide',
                meta: {
                    title: '数据优化'
                },
                component: transactionHide
            },
            {
                path: '/transactionHideAdd',
                name: 'transactionHideAdd',
                meta: {
                    title: '数据优化添加'
                },
                component: transactionHideAdd
            },
            {
                path: '/transactionHideInfo',
                name: 'transactionHideInfo',
                meta: {
                    title: '数据优化详情'
                },
                component: transactionHideInfo
            },
            {
                path: '/terminalStatistics',
                name: 'terminalStatistics',
                meta: {
                    title: '终端统计'
                },
                component: terminalStatistics
            },
            {
                path: '/upsideOrder',
                name: 'upsideOrder',
                meta: {
                    title: '倒挂订单审核'
                },
                component: level == 0 ? upsideOrder : developing
            },
            {
                path: '/ladderLog',
                name: 'ladderLog',
                meta: {
                    title: '阶梯记录查询'
                },
                component: ladderLog
            },
            {
                path: '/downloadList',
                name: 'downloadList',
                meta: {
                    title: '下载列表'
                },
                component: downloadList
            },
            {
                path: '/cashBackRecode',
                name: 'cashBackRecode',
                meta: {
                    title: '押金返现记录查询'
                },
                component: cashBackRecode
            },
            {
                path: '/mercServerFinishList',
                name: 'mercServerFinishList',
                meta: {
                    title: '商户服务费达标明细'
                },
                component: mercServerFinishList
            },
            {
                path: '/merchantWithdrawAudit',
                name: 'merchantWithdrawAudit',
                meta: {
                    title: '商户服务费提现'
                },
                component: merchantWithdrawAudit
            },
            {
                path: '/flowBackRecode',
                name: 'flowBackRecode',
                meta: {
                    title: '流量卡返现记录查询'
                },
                component: flowBackRecode
            },
            
            {
                path: '/activityCenter',
                name: 'activityCenter',
                meta: {
                    title: '活动中心'
                },
                component: activityCenter
            },
            {
                path: '/superiorSubsidyRecord',
                name: 'superiorSubsidyRecord',
                meta: {
                    title: '上级补贴记录'
                },
                component: superiorSubsidyRecord
            },
            {
                path: '/riskControlList',
                name: 'riskControlList',
                meta: {
                    title: '伪激活扣款列表'
                },
                component: riskControlList
            },
            {
                path: '/riskActiveList',
                name: 'riskActiveList',
                meta: {
                    title: '未激活扣款列表'
                },
                component: riskActiveList
            },
            {
                path: '/superiorMoney',
                name: 'superiorMoney',
                meta: {
                    title: '上级扣款列表'
                },
                component: superiorMoney
            },
            {
                path: '/subordinateMoney',
                name: 'subordinateMoney',
                meta: {
                    title: '下级回款列表'
                },
                component: subordinateMoney
            },
        ]
    },
    {
        path: '/merchats',
        name: 'merchats',
        meta: {
            title: '商户管理'
        },
        component: layout,
        children: [
            {
                path: '/merchantNet',
                name: 'merchantNet',
                meta: {
                    title: '商户进件(银盛)'
                },
                component: merchantNet
            },
            {
                path: '/merchantRefundList',
                name: 'merchantRefundList',
                meta: {
                    title: '商户退汇列表'
                },
                component: MerchantRefundList
            },
            {
                path: '/balanceCashDown',
                name: 'balanceCashDown',
                meta: {
                    title: '商户余额提现'
                },
                component: balanceCashDown
            },
            {
                path: '/balanceCashDownRecord',
                name: 'balanceCashDownRecord',
                meta: {
                    title: '商户余额提现记录'
                },
                component: balanceCashDownRecord
            },
            {
                path: '/merchantNetMany',
                name: 'merchantNetMany',
                meta: {
                    title: '商户进件'
                },
                component: merchantNetMany
            },
            {
                path: '/merchantNetManyInfo',
                name: 'merchantNetManyInfo',
                meta: {
                    title: '商户详情'
                },
                component: merchantNetManyInfo
            },
            {
                path: '/terminalUnbindList',
                name: 'terminalUnbindList',
                meta: {
                    title: '解绑列表'
                },
                component: terminalUnbindList
            },
            {
                path: '/companyMerchantNetAdd',
                name: 'companyMerchantNetAdd',
                meta: {
                    title: '企业商户进件新增'
                },
                component: companyMerchantNetAdd
            },
            {
                path: '/companyMerchantNetUpdate',
                name: 'companyMerchantNetUpdate',
                meta: {
                    title: '企业商户进件编辑'
                },
                component: companyMerchantNetUpdate
            },
            {
                path: '/companyMerchantNetUpdates',
                name: 'companyMerchantNetUpdates',
                meta: {
                    title: '企业商户进件编辑'
                },
                component: companyMerchantNetUpdates
            },
            {
                path: '/companyMerchantNetInfo',
                name: 'companyMerchantNetInfo',
                meta: {
                    title: '企业商户进件详情'
                },
                component: companyMerchantNetInfo
            },
            {
                path: '/companyMerchantNetModify',
                name: 'companyMerchantNetModify',
                meta: {
                    title: '企业商户信息修改'
                },
                component: companyMerchantNetModify
            },
            {
                path: '/merchantDeduction',
                name: 'merchantDeduction',
                meta: {
                    title: '商户投诉处处理'
                },
                component: merchantDeduction
            },
            {
                path: '/merchantDeductionAdd',
                name: 'merchantDeductionAdd',
                meta: {
                    title: '商户投诉添加'
                },
                component: merchantDeductionAdd
            },
            {
                path: '/companyMerchantNet',
                name: 'companyMerchantNet',
                meta: {
                    title: '企业商户进件管理'
                },
                component: companyMerchantNet
            },
            {
                path: '/merchantNetInfo',
                name: 'merchantNetInfo',
                meta: {
                    title: '商户详情'
                },
                component: merchantNetInfo
            },
            {
                path: '/merchantNetInfoUpdate',
                name: 'merchantNetInfoUpdate',
                meta: {
                    title: '商户资料'
                },
                component: merchantNetInfoUpdate
            },
            {
                path: '/rateTemplateManagement',
                name: 'rateTemplateManagement',
                meta: {
                    title: '费率模板管理'
                },
                component: rateTemplateManagement
            },
            {
                path: '/merchantClassSetting',
                name: 'merchantClassSetting',
                meta: {
                    title: '商户分类设置'
                },
                component: merchantClassSetting
            },
            {
                path: '/forceUnBind',
                name: 'forceUnBind',
                meta: {
                    title: '强制解绑列表'
                },
                component: forceUnBind
            },
            {
                path: '/rateDiscountSettings',
                name: 'rateDiscountSettings',
                meta: {
                    title: '费率折扣设置'
                },
                component: rateDiscountSettings
            },
            {
                path: '/merchantSurchargeManagement',
                name: 'merchantSurchargeManagement',
                meta: {
                    title: '商户附加费管理'
                },
                component: merchantSurchargeManagement
            },
            {
                path: '/merchantSurchargeManagementDetails',
                name: 'merchantSurchargeManagementDetails',
                meta: {
                    title: '商户附加费管理详情'
                },
                component: merchantSurchargeManagementDetails
            },
            {
                path: '/mobilePOSMerchant',
                name: 'mobilePOSMerchant',
                meta: {
                    title: '手机pos商户'
                },
                component: mobilePOSMerchant
            },
            {
                path: '/mobilePOSMerchantInfo',
                name: 'mobilePOSMerchantInfo',
                meta: {
                    title: '手机pos商户详情'
                },
                component: mobilePOSMerchantInfo
            },
            {
                path: '/mercSpeBundDetail',
                name: 'mercSpeBundDetail',
                meta: {
                    title: '商户特惠绑卡明细'
                },
                component: mercSpeBundDetail
            },
        ]
    },
    {
        path: '/financia',
        name: 'financia',
        meta: {
            title: '财务管理'
        },
        component: layout,
        children: [
            {
                path: '/userWithdrawal',
                name: 'userWithdrawal',
                meta: {
                    title: '代理商提现'
                },
                component: userWithdrawal
            },
            {
                path: '/agentWithdrawal',
                name: 'agentWithdrawal',
                meta: {
                    title: '机构提现列表'
                },
                component: agentWithdrawal
            },
            {
                path: '/agentExamine',
                name: 'agentExamine',
                meta: {
                    title: '审核提现'
                },
                component: agentExamine
            },
            {
                path: '/penaltyDeduction',
                name: 'penaltyDeduction',
                meta: {
                    title: '处罚扣款'
                },
                component: penaltyDeduction
            },
            {
                path: '/flowBackExtra',
                name: 'flowBackExtra',
                meta: {
                    title: '流量卡扣款'
                },
                component: flowBackExtra
            },
            {
                path: '/userPurse',
                name: 'userPurse',
                meta: {
                    title: '用户钱包'
                },
                component: userPurse
            },
            {
                path: '/userFinancial',
                name: 'userFinancial',
                meta: {
                    title: '用户财务记录'
                },
                component: userFinancial
            },
            {
                path: '/userAlipayRecord',
                name: 'userAlipayRecord',
                meta: {
                    title: '用户支付宝支付记录'
                },
                component: userAlipayRecord
            },
            {
                path: '/platformAccount',
                name: 'platformAccount',
                meta: {
                    title: '平台账户'
                },
                component: platformAccount
            },
            {
                path: '/agentinaccountList',
                name: 'agentinaccountList',
                meta: {
                    title: '收入'
                },
                component: agentinaccountList
            },
            {
                path: '/agentaccountList',
                name: 'agentaccountList',
                meta: {
                    title: '明细'
                },
                component: agentaccountList
            },
            {
                path: '/agentWithdrawalLists',
                name: 'agentWithdrawalLists',
                meta: {
                    title: '提现收入'
                },
                component: agentWithdrawalLists
            },
            {
                path: '/rateMonth',
                name: 'rateMonth',
                meta: {
                    title: '月结费率设置'
                },
                component: rateMonth
            },
            {
                path: '/agentoutaccountList',
                name: 'agentoutaccountList',
                meta: {
                    title: '提现'
                },
                component: agentoutaccountList
            },
            {
                path: '/agentAccountAllList',
                name: 'agentAccountAllList',
                meta: {
                    title: '活动账户明细'
                },
                component: agentAccountAllList
            },
            {
                path: '/agentAccountMarketAllList',
                name: 'agentAccountMarketAllList',
                meta: {
                    title: '市场账户明细'
                },
                component: agentAccountMarketAllList
            },
            {
                path: '/agentAccountProfitAllList',
                name: 'agentAccountProfitAllList',
                meta: {
                    title: '分润账户明细'
                },
                component: agentAccountProfitAllList
            },
            {
                path: '/moneyStatistics',
                name: 'moneyStatistics',
                meta: {
                    title: '平台支出统计'
                },
                component: moneyStatistics
            },
            {
                path: '/marketAccount',
                name: 'marketAccount',
                meta: {
                    title: '市场账户充值审核'
                },
                component: marketAccount
            },
        ]
    },
    {
        path: '/app',
        name: 'app',
        meta: {
            title: 'APP管理'
        },
        component: layout,
        children: [
            {
                path: '/banner',
                name: 'banner',
                meta: {
                    title: 'banner图管理'
                },
                component: level == 0 ? banner : developing
            },
            {
                path: '/bannerInfo',
                name: 'bannerInfo',
                meta: {
                    title: 'banner图详情'
                },
                component: bannerInfo
            },
            {
                path: '/recruit',
                name: 'recruit',
                meta: {
                    title: '招募背景管理'
                },
                component: level == 0 ? recruit : developing
            },
            {
                path: '/recruitInfo',
                name: 'recruitInfo',
                meta: {
                    title: '招募背景详情'
                },
                component: recruitInfo
            },
            {
                path: '/feedback',
                name: 'feedback',
                meta: {
                    title: '意见反馈'
                },
                component: level == 0 ? feedback : developing
            },
            {
                path: '/informationList',
                name: 'informationList',
                meta: {
                    title: '消息列表'
                },
                component: informationList
            },
            {
                path: '/informationInfo',
                name: 'informationInfo',
                meta: {
                    title: '消息详情'
                },
                component: informationInfo
            }
        ]
    },
    {
        path: '',
        name: 'businessCollege',
        meta: {
            title: '商学院'
        },
        component: layout,
        children: [
            {
                path: '/articleCategory',
                name: 'articleCategory',
                meta: {
                    title: '文章分类'
                },
                component: level == 0 ? articleCategory : developing
            },
            {
                path: '/articleList',
                name: 'articleList',
                meta: {
                    title: '文章列表'
                },
                component: level == 0 ? articleList : developing
            },
            {
                path: '/articleInfo',
                name: 'articleInfo',
                meta: {
                    title: '文章详情'
                },
                component: articleInfo
            }
        ]
    },
    {
        path: '',
        name: 'editPassword',
        meta: {
            title: '修改密码'
        },
        component: layout,
        children: [
            {
                path: '/editPassword',
                component: editPassword,
            }
        ]
    },
    {
        path: '/helpCenter',
        name: 'helpCenter',
        meta: {
            title: '帮助中心'
        },
        component: layout,
        children: [
            {
                path: '/helpClass',
                name: 'helpClass',
                meta: {
                    title: '帮助分类'
                },
                component: level == 0 ? helpClass : developing
            },
            {
                path: '/helpList',
                name: 'helpList',
                meta: {
                    title: '帮助列表'
                },
                component: level == 0 ? helpList : developing
            },
            {
                path: '/helpInfo',
                name: 'helpInfo',
                meta: {
                    title: '帮助详情'
                },
                component: helpInfo
            },
        ]
    },
    {
        path: '/serviceManagement',
        name: 'serviceManagement',
        meta: {
            title: '客服管理'
        },
        component: layout,
        children: [
            {
                path: '/serviceApplication',
                name: 'serviceApplication',
                meta: {
                    title: '客服申请'
                },
                component: level == 0 ? serviceApplication : developing
            },
            {
                path: '/serviceRenew',
                name: 'serviceRenew',
                meta: {
                    title: '客服续费'
                },
                component: level == 0 ? serviceRenew : developing
            }
        ]
    },
    {
        path: '/teamLeaderManagement',
        name: 'teamLeaderManagement',
        meta: {
            title: '团长管理'
        },
        component: layout,
        children: [
            {
                path: '/teamLeaderManagementList',
                name: 'teamLeaderManagementList',
                meta: {
                    title: '团长管理'
                },
                component: teamLeaderManagementList
            },
            {
                path: '/teamMoneyShenList',
                name: 'teamMoneyShenList',
                meta: {
                    title: '团长提现审核'
                },
                component: teamMoneyShenList
            },
            {
                path: '/teamTixianManger',
                name: 'teamTixianManger',
                meta: {
                    title: '提现管理'
                },
                component: teamTixianManger
            },
            {
                path: '/teamTixianRecord',
                name: 'teamTixianRecord',
                meta: {
                    title: '提现记录'
                },
                component: teamTixianRecord
            },
            {
                path: '/costing',
                name: 'costing',
                meta: {
                    title: '成本核算'
                },
                component: costing
            },
            {
                path: '/rewardDetails',
                name: 'rewardDetails',
                meta: {
                    title: '奖励明细'
                },
                component: rewardDetails
            },
            {
                path: '/terminalPickup',
                name: 'terminalPickup',
                meta: {
                    title: '终端拿货'
                },
                component: terminalPickup
            },
            {
                path: '/differenceShareProfit',
                name: 'differenceShareProfit',
                meta: {
                    title: '分润差额'
                },
                component: differenceShareProfit
            },
            {
                path: '/trafficCardSharing',
                name: 'trafficCardSharing',
                meta: {
                    title: '流量卡分成'
                },
                component: trafficCardSharing
            },
            {
                path: '/profitWithdrawalPoint',
                name: 'profitWithdrawalPoint',
                meta: {
                    title: '分润账户提现税点'
                },
                component: profitWithdrawalPoint
            },
            {
                path: '/activityWithdrawalPoint',
                name: 'activityWithdrawalPoint',
                meta: {
                    title: '达标返现账户提现税点'
                },
                component: activityWithdrawalPoint
            },
            {
                path: '/depositWithdrawalPoint',
                name: 'depositWithdrawalPoint',
                meta: {
                    title: '押金账户提现税点'
                },
                component: depositWithdrawalPoint
            },
            {
                path: '/rewardAccountShaiDian',
                name: 'rewardAccountShaiDian',
                meta: {
                    title: '奖励账户提现税点'
                },
                component: rewardAccountShaiDian
            },
            {
                path: '/specialRewardDetail',
                name: 'specialRewardDetail',
                meta: {
                    title: '特惠奖励账户提现税点'
                },
                component: specialRewardDetail
            },
            {
                path: '/bigAwardDetail',
                name: 'bigAwardDetail',
                meta: {
                    title: '大盘分红账户提现税点'
                },
                component: bigAwardDetail
            },
            {
                path: '/mangerAwardDetail',
                name: 'mangerAwardDetail',
                meta: {
                    title: '管理奖账户提现税点'
                },
                component: mangerAwardDetail
            },
            {
                path: '/downSalaryReward',
                name: 'downSalaryReward',
                meta: {
                    title: '底薪奖账户提现税点'
                },
                component: downSalaryReward
            },
            {
                path: '/flowCardCostDetail',
                name: 'flowCardCostDetail',
                meta: {
                    title: '流量卡账户提现税点'
                },
                component: flowCardCostDetail
            }
            
        ]
    },
    {
        path: '/freeAdjustmentPrice',
        name: 'freeAdjustmentPrice',
        meta: {
            title: '自由调价管理'
        },
        component: layout,
        children: [
            {
                path: '/rightsManagement',
                name: 'rightsManagement',
                meta: {
                    title: '自由调价权限管理'
                },
                component: rightsManagement
            },
            {
                path: '/blacklistManagement',
                name: 'blacklistManagement',
                meta: {
                    title: '调价黑名单管理'
                },
                component: blacklistManagement
            },
            {
                path: '/rateAdjustmentRecord',
                name: 'rateAdjustmentRecord',
                meta: {
                    title: '费率调价记录'
                },
                component: rateAdjustmentRecord
            },
            {
                path: '/secondsAdjustmentRecord',
                name: 'secondsAdjustmentRecord',
                meta: {
                    title: '秒到费调价记录'
                },
                component: secondsAdjustmentRecord
            },
            {
                path: '/freeFenMoney',
                name: 'freeFenMoney',
                meta: {
                    title: '自由调价分润明细'
                },
                component: freeFenMoney
            }
        ]
    },
    {
        path: '/saleManger',
        name: 'saleManger',
        meta: {
            title: '销售管理'
        },
        component: layout,
        children: [
            {
                path: '/saleMangerPerson',
                name: 'saleMangerPerson',
                meta: {
                    title: '销售管理列表'
                },
                component: saleMangerPerson
            },
            {
                path: '/salePersonLinkAgent',
                name: 'salePersonLinkAgent',
                meta: {
                    title: '销售&代理'
                },
                component: salePersonLinkAgent
            },
            {
                path: '/salePersonTask',
                name: 'salePersonTask',
                meta: {
                    title: '销售任务'
                },
                component: salePersonTask
            },
            {
                path: '/saleTixianShen',
                name: 'saleTixianShen',
                meta: {
                    title: '销售提现审核'
                },
                component: saleTixianShen
            },
            {
                path: '/saleRewardDetail',
                name: 'saleRewardDetail',
                meta: {
                    title: '奖励明细'
                },
                component: saleRewardDetail
            }
        ]
    },
    {
        path: '/grayPlan',
        name: 'grayPlan',
        meta: {
            title: '灰名单管理'
        },
        component: layout,
        children: [
            {
                path: '/grayPlanList',
                name: 'grayPlanList',
                meta: {
                    title: '优化方案管理'
                },
                component: grayPlanList
            },
            {
                path: '/grayPlanNewList',
                name: 'grayPlanNewList',
                meta: {
                    title: '优化方案管理-新'
                },
                component: grayPlanNewList
            },
            {
                path: '/grayPlanTraceList',
                name: 'grayPlanTraceList',
                meta: {
                    title: '数据恢复管理'
                },
                component: grayPlanTraceList
            },
            {
                path: '/grayPlanTraceNormalList',
                name: 'grayPlanTraceNormalList',
                meta: {
                    title: '数据恢复记录'
                },
                component: grayPlanTraceNormalList
            },
            {
                path: '/agentWhiterList',
                name: 'agentWhiterList',
                meta: {
                    title: '代理商白名单优化管理'
                },
                component: agentWhiterList
            },
            {
                path: '/agentWhiterListNew',
                name: 'agentWhiterListNew',
                meta: {
                    title: '代理商白名单优化管理-新'
                },
                component: agentWhiterListNew
            },
            {
                path: '/mercWhiterList',
                name: 'mercWhiterList',
                meta: {
                    title: '商户白名单优化管理'
                },
                component: mercWhiterList
            },
            {
                path: '/mercWhiterListNew',
                name: 'mercWhiterListNew',
                meta: {
                    title: '商户白名单优化管理-新'
                },
                component: mercWhiterListNew
            }
        ]
    },
]
export default routes;